<template>
  <TableRow>
    <Cell>
      <InputText class="name" v-model="editedUser.firstName" />
    </Cell>
    <Cell>
      <InputText class="name" v-model="editedUser.lastName" />
    </Cell>
    <Cell>
      <InputText v-model="editedUser.username" />
    </Cell>
    <Cell>
      <input
        v-model="editedUser.isAdmin"
        class="w-5 h-5"
        name="checkbox"
        type="checkbox"
        :disabled="isOnlyAdmin"
      />
    </Cell>
    <Cell>
      <div class="flex">
        <button
          @click="save"
          :disabled="disableSaveButton"
          :class="[
            'p-1 pl-2 pr-2',
            disableSaveButton ? 'disabled' : 'clickable'
          ]"
        >
          Save
        </button>
        <button
          v-if="isNewUser"
          @click="$emit('clear')"
          class="clickable p-1 pl-2 pr-2"
        >
          Clear
        </button>
        <button
          v-else
          @click="$emit('edit-cancelled')"
          class="clickable p-1 pl-2 pr-2"
        >
          Cancel
        </button>
      </div>
    </Cell>
  </TableRow>
</template>

<script setup>
import { ref, watch, computed } from "vue"
import ApiClient, { UserApi } from "../api/"

import TableRow from "./TableRow.vue"
import InputText from "./InputText.vue"
import Cell from "./Cell.vue"

const emit = defineEmits(["refresh-users", "edit-cancelled", "clear"])

const props = defineProps({
  user: {
    required: true,
    type: Object
  },
  isOnlyAdmin: {
    required: true,
    type: Boolean
  }
})

const editedUser = ref({ ...props.user })
watch(
  () => props.user,
  () => {
    editedUser.value = { ...props.user }
  }
)

const isNewUser = computed(() => {
  return props.user?.id === undefined
})

const changesExist = computed(() => {
  return JSON.stringify(props.user) !== JSON.stringify(editedUser.value)
})

const requiredInputs = ["firstName", "lastName", "username"]

const someMissingAttrs = computed(() => {
  return requiredInputs.some(prop => !editedUser.value[prop])
})

const disableSaveButton = computed(() => {
  if (!props.user) return true
  return !changesExist.value || someMissingAttrs.value
})

async function save() {
  isNewUser.value ? saveUser() : updateUser()
}

async function updateUser() {
  try {
    const response = await ApiClient.put(
      `/user/${editedUser.value.id}`,
      editedUser.value
    )
    if (response.status === 200) {
      emit("refresh-users")
      emit("edit-cancelled")
    }
  } catch (error) {
    console.log("error: ", error)
  }
}

async function saveUser() {
  try {
    const response = await UserApi.save({
      username: editedUser.value.username,
      firstName: editedUser.value.firstName,
      lastName: editedUser.value.lastName,
      isAdmin: editedUser.value.isAdmin
    })
    if (response.status === 200) {
      emit("clear")
      emit("refresh-users")
    }
  } catch (error) {
    console.log("error: ", error.response)
  }
}
</script>

<style scoped>
InputText {
  width: 100%;
}

InputText.name {
  min-width: 10rem;
}

button {
  margin-right: 10px;
  background: white;
  border-radius: 5px;
  outline: none;
  border: 1px solid rgb(156, 163, 175);
}
</style>
